
import Button from '@/components/UntitledUI/Button.vue'
import Sms2FA from '@/components/common/TwoFactorAuth/Sms2FA.vue'
import InputField from '@/components/UntitledUI/InputField.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: {
        Sms2FA,
        Button,
        InputField,
        Icon
    },
    layout: 'onboarding',
    auth: 'guest',
    data () {
        return {
            to: null,
            waitTime: 0,
            success: false,
            passwordSuccess: false,
            step: 1,
            hidden: {
                password: true,
                password_confirmation: true
            },
            sendCodeForm: new this.$vForm({
                email: '',
                recaptcha_token: ''
            }),
            verifyCodeForm: new this.$vForm({
                code: '',
                '2fa': undefined
            }),
            resetCodeForm: new this.$vForm({
                password: '',
                password_confirmation: '',
                '2fa': undefined
            })
        }
    },
    async mounted () {
        await this.$axios.$get('/v1/sanctum/csrf-cookie')
    },
    methods: {
        send () {},
        async sendRecoveryEmail () {
            if (this.sendCodeForm.busy) {
                return
            }
            try {
                await this.sendCodeForm.post('/v1/password/reset/send')
                    .then((res) => {
                        this.verifyCodeForm['2fa'] = res.data['2fa']
                        this.resetCodeForm['2fa'] = res.data['2fa']
                        this.waitTime = res.data.wait
                        this.to = res.data.to
                        this.step = 2
                    })
            } catch (e) {
                this.sendCodeForm.recaptcha_token = ''
                if (e.response?.status !== 422) {
                    throw e
                }
            }
        },
        async resetPassword () {
            if (this.resetCodeForm.busy) {
                return
            }
            try {
                await this.resetCodeForm.post('/v1/password/reset')
                this.passwordSuccess = true
                this.step = 4
            } catch (e) {
                if (e.response?.status !== 422) {
                    throw e
                }
            }
        },
        goToLogin () {
            this.$router.push('/Login')
        }
    },
    head: {
        title: 'إستعادة كلمة المرور'
    }
}
